import { match } from "@formatjs/intl-localematcher";
import { Locale } from "@obs/providers";

import { App } from "./App";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type SupportedLocale } from "./intl/constants";
import { normalizeLocale } from "./intl/normalizeLocale";

const URLSearchParams = new URL(window.location.href).searchParams;

export const LocaleProvider = () => {
	const DEFAULT_PRIMARY_LOCALE: SupportedLocale = match(
		Array.from(navigator.languages),
		SUPPORTED_LOCALES,
		DEFAULT_LOCALE,
	) as SupportedLocale;

	const defaultLocale = (URLSearchParams.get("locale") && normalizeLocale(URLSearchParams.get("locale")!)) || DEFAULT_PRIMARY_LOCALE;

	return (
		<Locale.Provider defaultLocale={defaultLocale} supportedLocales={Array.from(SUPPORTED_LOCALES)}>
			<App />
		</Locale.Provider>
	);
};
